import { IState } from '../../store';

export const selectTransportAccessibilitySource = (state: IState): string => {
  const { transportAccessibility } = state.offerData;

  if (!transportAccessibility) {
    return '/';
  }

  return transportAccessibility.sourceUrl;
};
